import './style.scss';
import Header from './components/Header';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <>
      <Header />
      <Footer />
    </>
  );
}

export default App;
